import { render, staticRenderFns } from "./CharTabs.vue?vue&type=template&id=95dec7c8&scoped=true"
import script from "./CharTabs.vue?vue&type=script&lang=js"
export * from "./CharTabs.vue?vue&type=script&lang=js"
import style0 from "./CharTabs.vue?vue&type=style&index=0&id=95dec7c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dec7c8",
  null
  
)

export default component.exports